import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';

import { AnySchemaComponent } from './AnySchemaComponent';

interface SchemaProps {
  imageUrl?: string;
  description?: string;
}

export const LocalBusinessSchema = ({
  imageUrl,
  description,
}: SchemaProps): JSX.Element => {
  const data = useStaticQuery<Queries.LocalBusinessQueryQuery>(graphql`
    query LocalBusinessQuery {
      homePageData: sanityHomePage {
        seo {
          title: metaTitle
          description: metaDescription
          ogImage: metaImage {
            asset {
              gatsbyImageData(
                layout: FULL_WIDTH
                placeholder: BLURRED
                formats: [AUTO, WEBP]
              )
            }
          }
        }
        heroCarousel {
          media {
            image {
              asset {
                url
                gatsbyImageData(
                  layout: FULL_WIDTH
                  placeholder: BLURRED
                  formats: [AUTO, WEBP]
                )
              }
              alt
            }
          }
        }
      }
    }
  `);

  const schemaString = `
    {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "image": [
        "${
          imageUrl ||
          data.homePageData?.heroCarousel?.[0]?.media?.image?.asset?.url
        }"
      ],
      "@id": "https://www.rockefellercenter.com/",
      "name": "Rockefeller Center",
      "description": "${description || data.homePageData?.seo?.description}",
      "telephone": "1-877-NYC-ROCK",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "45 Rockefeller Plaza",
        "addressLocality": "New York",
        "addressRegion": "NY",
        "postalCode": "10111",
        "addressCountry": "US"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 40.7587,
        "longitude": 73.9787
      }
    }
  `;

  return <AnySchemaComponent schemaString={schemaString} />;
};
